import { BuddyMessageFeedbackReaction } from './buddy-message-feedback-reaction';
import { BuddyMessageFeedbackFlag } from './buddy-message-feedback-flag';

export class BuddyMessageFeedback {
    reaction: BuddyMessageFeedbackReaction = BuddyMessageFeedbackReaction.NONE;
    flag?: BuddyMessageFeedbackFlag;
    comment?: string;
}
